import * as CookieConsent from 'vanilla-cookieconsent/dist/cookieconsent.esm.js'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import '@orestbida/iframemanager/dist/iframemanager.js'
import '@orestbida/iframemanager/dist/iframemanager.css'
;(function () {
  const im = window.iframemanager()

  im.run({
    onChange: ({ changedServices, eventSource }) => {
      if (eventSource.type === 'click') {
        // Get current accepted services (with fallback to empty array)
        const currentAccepted =
          CookieConsent.getUserPreferences().acceptedServices['thirdParty'] ||
          []
        // Create a simple array of services to accept
        const servicesToAccept = Array.from(
          new Set([...currentAccepted, ...changedServices])
        )
        // Accept all combined services
        CookieConsent.acceptService(servicesToAccept, 'thirdParty')
      }
    },
    currLang: 'en',
    services: {
      vimeo: {
        embedUrl: 'https://player.vimeo.com/video/{data-id}',
        iframe: {
          allow: 'fullscreen',
          params: 'byline=0&color=C83200&dnt=1',
        },
        cookie: {
          name: 'cc_vimeo',
          path: '/',
          samesite: 'lax',
          domain: location.hostname,
        },
        languages: {
          en: {
            notice:
              'This content is hosted on Vimeo. Allowing this content may set cookies and use data in accordance with the <a rel="noreferrer noopener" href="https://vimeo.com/privacy" target="_blank">Vimeo privacy policy</a>.',
            loadAllBtn: 'Allow Vimeo',
          },
        },
      },
      youtube: {
        embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
        iframe: {
          allow: 'fullscreen',
          params: 'color=white',
        },
        cookie: {
          name: 'cc_youtube',
          path: '/',
          samesite: 'lax',
          domain: location.hostname,
        },
        languages: {
          en: {
            notice:
              'This content is hosted on YouTube. Allowing this content may set cookies and use data in accordance with the <a rel="noreferrer noopener" href="https://policies.google.com/privacy" target="_blank">Google privacy policy</a>.',
            loadAllBtn: 'Allow YouTube',
          },
        },
      },
    },
  })

  CookieConsent.run({
    autoShow: false,
    categories: {
      essential: {
        enabled: true,
        readOnly: true,
      },
      thirdParty: {
        services: {
          vimeo: {
            label:
              'Vimeo embed (<a rel="noreferrer noopener" href="https://vimeo.com/privacy" target="_blank">Vimeo privacy policy</a>)',
            onAccept: () => im.acceptService('vimeo'),
            onReject: () => im.rejectService('vimeo'),
          },
          youtube: {
            label:
              'YouTube embed (<a rel="noreferrer noopener" href="https://policies.google.com/privacy" target="_blank">Google privacy policy</a>)',
            onAccept: () => im.acceptService('youtube'),
            onReject: () => im.rejectService('youtube'),
          },
        },
      },
    },
    language: {
      default: 'en',
      translations: {
        en: {
          preferencesModal: {
            title: 'Cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Save selection',
            closeIconLabel: 'Close',
            sections: [
              {
                description:
                  'We use minimal cookies and resources to provide you with a privacy focused experience. We do embed content on our website from third parties, which is only activated with your consent.',
              },
              {
                title: 'Essential cookies',
                description:
                  'We use cookies to save your preferences and help with core functionality of the website such as signing in, purchasing plans/products, and saving progress.',
                linkedCategory: 'essential',
              },
              {
                title: 'Third party cookies',
                description:
                  'Sometimes we embed content from third-party websites. These providers may set their own cookies and use your data according to their policies. When embedding this content, we aim to use all of the privacy-protecting features they provide.',
                linkedCategory: 'thirdParty',
              },
            ],
          },
        },
      },
    },
  })
})()
